/**
 * The two pieces every palette section is built from.
 *
 * They live apart from the palette itself because the palette is now several files -- what
 * the next note will be, and what goes on the notes already written -- and a button that
 * looked different in one of them would read as a different kind of control.
 */

import { Kicker } from "./Page";
import type { ReactNode } from "react";

export function Button({
  title,
  on = false,
  disabled = false,
  onClick,
  children,
}: {
  title: string;
  on?: boolean;
  disabled?: boolean;
  onClick(): void;
  children: ReactNode;
}): JSX.Element {
  const look = on
    ? "border-ink bg-ink text-white"
    : "border-rule text-ink-faded hover:border-ink-quiet hover:text-ink";
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      aria-pressed={on}
      disabled={disabled}
      onClick={onClick}
      className={`flex h-9 items-center justify-center rounded-[8px] border text-[13px] disabled:cursor-default disabled:border-rule disabled:text-ink-quiet/60 ${look}`}
    >
      {children}
    </button>
  );
}

export function Section({ title, children }: { title: string; children: ReactNode }): JSX.Element {
  return (
    <div className="space-y-1.5">
      <Kicker>{title}</Kicker>
      <div className="grid grid-cols-3 gap-1.5">{children}</div>
    </div>
  );
}
